import { ComponentRef, Directive, effect, ElementRef, inject, input, OnDestroy, Renderer2, ViewContainerRef } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Directive({
  selector: '[appLoadingButton]'
})
export class LoadingButtonDirective implements OnDestroy {
  readonly loading = input(false, { alias: 'appLoadingButton' });

  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly renderer = inject(Renderer2);
  private readonly viewContainerRef = inject(ViewContainerRef);

  private spinnerRef?: ComponentRef<MatProgressSpinner>;

  private readonly _ = effect(() => {
      if (this.loading()) {
        this.showSpinner();
      } else {
        this.hideSpinner();
      }
    });


  private showSpinner(): void {
    if (this.spinnerRef) {
      return;
    }
    Array.from(this.elementRef.nativeElement.children).forEach(child => {
      this.renderer.setStyle(child, 'visibility', 'hidden');
    });

    this.spinnerRef = this.viewContainerRef.createComponent(MatProgressSpinner);
    this.spinnerRef.setInput('diameter', 20);
    this.spinnerRef.setInput('mode', 'indeterminate');

    const spinnerElement: HTMLElement = this.spinnerRef.location.nativeElement;
    this.renderer.setStyle(spinnerElement, 'position', 'absolute');
    this.renderer.setStyle(spinnerElement, 'top', '50%');
    this.renderer.setStyle(spinnerElement, 'left', '50%');
    this.renderer.setStyle(spinnerElement, 'transform', 'translate(-50%, -50%)');
    this.renderer.appendChild(this.elementRef.nativeElement, spinnerElement);
  }

  private hideSpinner(): void {
    const spinnerElement = this.spinnerRef?.location.nativeElement;
    Array.from(this.elementRef.nativeElement.children).forEach(child => {
      if (child !== spinnerElement) {
        this.renderer.removeStyle(child, 'visibility');
      }
    });
    this.spinnerRef?.destroy();
    this.spinnerRef = undefined;
  }

  ngOnDestroy(): void {
    this.spinnerRef?.destroy();
  }
}
